<template>
  <autocomplete-field
    v-bind="$attrs"
    :data-testid="props.dataTestid"
    :loading="cache[props.cacheItemsKey].loading"
    :items="cache[props.cacheItemsKey].items"
  >
    <template v-if="$slots['append-inner']" #append-inner>
      <slot name="append-inner" />
    </template>
  </autocomplete-field>
</template>

<script setup>
import { useSearchItemsCache } from "@/stores/search-items-cache";
import { parseErrorMessage } from "@/util/helpers";
import { useSnackbarStore } from "@/stores/snackbar";
const props = defineProps({
  cacheFetchKey: { type: String, required: true },
  cacheItemsKey: { type: String, required: true },
  dataTestid: { type: String, required: false, default: null }
});

const cache = useSearchItemsCache();
const snackbar = useSnackbarStore();

async function getItems() {
  try {
    await cache[props.cacheFetchKey]();
  } catch (e) {
    snackbar.showErrorSnackbar({ message: parseErrorMessage(e) });
  }
}

getItems();
</script>
